<template>
    <modal name="broker-completion-required-modal"
        :adaptive="true"
        :width="520"
        height="auto"
        :styles="{ boxShadow: 'none', background: 'transparent' }"
        @before-close="handleBeforeClose"
    >
        <div class="rounded-lg bg-white p-10"
            @click.stop
        >
            <div class="flex flex-col mb-6">
                <div class="flex-shrink-0 leading-snug text-gray-600 text-lg">
                    Before your envelope is sent to other signers, there are fields that you must complete.
                </div>

                <div class="text-gray-600 leading-snug mt-6 mb-2 outline-none" tabindex="0">
                    Click <span class="font-semibold">Continue to Docusign</span> to complete your fields, then click <span class="font-semibold">Finish</span> on the next screen when you are done.
                </div>
            </div>

            <div class="flex items-center justify-between pt-4">
                <button-gray-outline @click="close">
                    Cancel
                </button-gray-outline>

                <button-blue @click="launchDocusign">
                    Continue to Docusign
                </button-blue>
            </div>
        </div>
    </modal>
</template>

<script>
import ButtonBlue from '../../../components/button-blue.vue';
import ButtonGrayOutline from '../../../components/button-gray-outline.vue';

export default {
    components: {
        ButtonBlue,
        ButtonGrayOutline,
    },

    props: {
        show: {},
    },

    methods: {
        close(event) {
            this.$emit('closed');
        },
        handleBeforeClose(event) {
            // Only emit closed if the close wasn't triggered by our buttons
            if (! event.stop) {
                this.$emit('closed');
            }
        },
        launchDocusign() {
            this.$emit('closed');
            this.$emit('launchDocusign');
        },
    },

    watch: {
        show: {
            handler(val) {
                if (val) {
                    this.$nextTick(() => {
                        this.$modal.show('broker-completion-required-modal');
                    });
                } else {
                    this.$modal.hide('broker-completion-required-modal');
                }
            },
            immediate: true,
        },
    },
}
</script>

<style scoped>
.vm--overlay {
    background: #000000;
    opacity: 0.7;
}

.overlay-enter,
.overlay-leave-to {
    opacity: 0;
}

.overlay-enter-active,
.overlay-leave-active {
    transition: all .3s;
}
</style>
